import Vue from 'vue'
import VueCookies from 'vue-cookies'
import api from '../../api/leadRealAPI'

Vue.use(VueCookies)

export default {
  namespaced: true,

  state: {
    latestMember: null,
    allMember: null,
    memberRegistrationDates: null
  },

  getters: {
    latestMember: state => state.latestMember,
    allMember: state => state.allMember,
    memberRegistrationDates: state => state.memberRegistrationDates
  },

  mutations: {
    setLatestMember (state, latestMember) {
      state.latestMember = latestMember
    },
    setAllMember (state, allMember) {
      state.allMember = allMember
    },
    setMemberRegistrationDates (state, memberRegistrationDates) {
      state.memberRegistrationDates = memberRegistrationDates
    }
  },

  actions: {
    getLatestMember ({ commit }) {
      api
        .get('admin/latestRegistered')
        .then(response => {
          commit('setLatestMember', response.data)
        })
        .catch(() => {})
    },
    getAllMember ({ commit }) {
      api
        .get('admin/memberList')
        .then(response => {
          commit('setAllMember', response.data)
        })
        .catch(() => {})
    },
    getMemberRegistrationDates ({ commit }) {
      api
        .get('admin/memberRegistrationDates')
        .then(response => {
          commit('setMemberRegistrationDates', response.data)
        })
        .catch(() => {})
    },
    getCsv ({ commit }, data) {
      api
        .post('/admin/exportMemberList/', data, {
          responseType: 'blob'
        })
        .then(response => {
          const url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'memberList')
          document.body.appendChild(link)
          link.click()
        })
        .catch()
    }
  }
}
